const NotFound = () => {
  return (
    <div className="flex items-center justify-center h-full min-h-screen bg-black text-white">
      <div className="text-center">
        <h1 className="text-6xl font-bold">404 😢</h1>
        <p className="text-xl mt-4">
          Oops! The page you are looking for does not exist.
        </p>
        <div className="mt-5">
          <a href="/" className="btn">
            Return to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
